export const PANEL_WIDTH = 362

//APP ENV
export const APP_ENV_PRODUCTION_LIST = ['prd', 'production']
